export type UseControlsReducerState = {
  isPagesAndBlocks: boolean
  isSeoMetaTags: boolean
  isWireframeTypes: boolean
  isBlocksContents: boolean
  isSections: boolean
  isNotes: boolean
  withoutBlocks?: boolean
}

export enum UseControlsActionTypes {
  SET_PAGES_BLOCKS = 'SET_PAGES_BLOCKS',
  SET_SEO_META = 'SET_SEO_META',
  SET_WIREFRAMES = 'SET_WIREFRAMES',
  SET_BLOCKS_CONTENTS = 'SET_BLOCKS_CONTENTS',
  SET_SECTIONS = 'SET_SECTIONS',
  SET_NOTES = 'SET_NOTES',
}

export type UseControlsActions =
  | {
      type: UseControlsActionTypes.SET_PAGES_BLOCKS
    }
  | {
      type: UseControlsActionTypes.SET_SEO_META
    }
  | {
      type: UseControlsActionTypes.SET_WIREFRAMES
    }
  | {
      type: UseControlsActionTypes.SET_BLOCKS_CONTENTS
    }
  | {
      type: UseControlsActionTypes.SET_SECTIONS
    }
  | {
      type: UseControlsActionTypes.SET_NOTES
    }

export type UseReducerActions = {
  setPagesBlocks: () => void
  setSeoMeta: () => void
  setWireframes: () => void
  setBlocksContents: () => void
  setSections: () => void
  setNotes: () => void
}

export type UseControls = {
  actions: UseReducerActions
  state: UseControlsReducerState
}
